var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v("Read at "+_vm._s(_vm._f("formatDateTime")(_vm.row.createdOn)))]),_vm._v(" "),_c('br'),_c('router-link',{attrs:{"to":`/admin/messages/${_vm.row.data.messageId}`}},[_vm._v("View Message")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }